import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  backgroundColor: theme.palette.background.default,
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

type Row = {
  title: string;
  content: string;
};

const CustomTable = ({ rows }: { rows: Row[] }) => {
  return (
    <TableContainer component={Paper}>
      <Table aria-label="custom table">
        <TableBody className="table-body">
          {rows.map((row) => (
            <StyledTableRow key={row.title} className="table-row">
              <StyledTableCell scope="row" className="table-cell">
                <h3>{row.title}</h3>
              </StyledTableCell>
              <StyledTableCell className="table-cell-desc">
                <p>{row.content}</p>
              </StyledTableCell>
            </StyledTableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default CustomTable;
